import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './styles.css';

// Le verre s'illumine depuis le point touché (design system, « Matériau ») : la position de
// l'appui est donnée au contrôle en --fc-x / --fc-y.
document.addEventListener(
  'pointerdown',
  (e) => {
    const cible =
      e.target instanceof Element ? e.target.closest<HTMLElement>('.fc-bouton, .fc-note') : null;
    if (!cible) return;
    const r = cible.getBoundingClientRect();
    cible.style.setProperty('--fc-x', `${e.clientX - r.left}px`);
    cible.style.setProperty('--fc-y', `${e.clientY - r.top}px`);
  },
  { passive: true },
);

createRoot(document.getElementById('racine')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
